<template>
  <v-form ref="form">
    <v-row class="mt-2">
      <v-col cols="12" sm="6" md="4" class="d-flex">
        <BaseTextField
          v-model="couponData.couponCode"
          :label="$t('sales.discount-coupon.coupon-code')"
          :placeholder="$t('sales.discount-coupon.insert-coupon-code')"
          :rules="[rules.required, rules.specialCharacters]"
          maxlength="16"
          counter="16"
        >
          <template v-slot:append-outer>
            <ToolTip :text="$t('sales.discount-coupon.coupon-code-tooltip')" />
          </template>
        </BaseTextField>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <DateTimePicker
          :label="$t('sales.discount-coupon.expiration-start-date')"
          :placeholder="'dd/mm/aaaa - hh:mm'"
          :edit="couponData.initDateTime"
          :rules="[rules.required]"
          @formatted-date="handleInitDateTime"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <DateTimePicker
          :label="$t('sales.discount-coupon.expiration-finish-date')"
          :placeholder="'dd/mm/aaaa - hh:mm'"
          :edit="couponData.finalDateTime"
          :rules="[rules.required]"
          @formatted-date="handleFinalDateTime"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import formRules from "../../../mixins/formRules";
import BaseTextField from "../../forms/BaseTextField.vue";
import DateTimePicker from "../../forms/DateTimePicker.vue";
import ToolTip from "./ToolTip.vue";

export default {
  name: "CouponInformation",
  mixins: [formRules],
  components: {
    BaseTextField,
    DateTimePicker,
    ToolTip,
  },
  computed: {
    ...mapGetters(["couponData"]),
  },
  methods: {
    handleInitDateTime(formatteddatetime) {
      this.couponData.initDateTime = formatteddatetime;
    },
    handleFinalDateTime(formatteddatetime) {
      this.couponData.finalDateTime = formatteddatetime;
    },
  },
};
</script>

<style lang="scss" scoped></style>
